// extracted by mini-css-extract-plugin
export default {"error":"BeforeSignErrors_error__YxE3f","active":"BeforeSignErrors_active__MIf67","button":"BeforeSignErrors_button__zpi0d"};